import axios from 'axios';

const API_URL = 'https://apischlinux.trayistats.com';
// const API_URL = 'http://localhost:5010';

// Get all cron jobs
export const getCronJobs = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/getAllCronjobs`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get a single cron job by ID
export const getCronJobById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/getCronJobById/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new cron job
export const createCronJob = async (cronJob) => {
  try {
    const response = await axios.post(`${API_URL}/api/createCronjobs`, cronJob);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing cron job
export const updateCronJob = async (cronJob) => {
  try {
    const response = await axios.put(`${API_URL}/api/updateCronjobs/${cronJob.id}`, cronJob);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a cron job by ID
export const deleteCronJob = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/deleteCronjobs/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update status for one or more cron jobs
export const updateCronJobStatus = async ({ ids, status }) => {
  try {
    const response = await axios.put(`${API_URL}/api/updateCronjobsStatus`, { ids, status });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ===========================
// NEW: Get cron logs by cron ID
// ===========================
export const getCronLogs = async (cronId) => {
  try {
    // This endpoint should return logs only for the specified cron job
    const response = await axios.get(`${API_URL}/api/cronLogs/${cronId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
